import { Outlet, useLocation } from "react-router-dom";
import AppInternetReconnectingBox from "../../socket/appComponents/UtilsComponents/AppInternetReconnectingBox";
import SocketSessionInfoModel from "../../socket/appComponents/UtilsComponents/SocketSessionInfoModel";
import { SocketContextProvider } from "../../socket/hooks/socket-context";
import LeftMenu from "../Menu/LeftMenu";
import TopMenu from "../Menu/TopMenu";
import ExpireSubscription from "../Subscription/Expired/ExpireSubscription";

import {
  ContentWrap,
  HomeLayoutWrap,
  HomeLayoutWrapLeft,
  HomeLayoutWrapRight,
} from "./ClientLayout";
import { useAppSelector } from "../../Store";
import { useAuthStore } from "../../Store/Slices/AuthSlice";
import { isEmptyObject } from "../../Utils";
import { Suspense } from "react";
import LinearLoader from "../../AppComponents/Loader/LinearLoader";
import NotificationBar from "../Menu/notification-bar";

const ProtectedLayout = () => {
  const { userConfig } = useAppSelector(useAuthStore);
  const location = useLocation();
  const permissionsData: any = userConfig?.payload?.allowed_permissions ?? null;
  if (
    !userConfig?.payload ||
    (window.localStorage.getItem("expiry_time") &&
      userConfig?.payload &&
      isEmptyObject(permissionsData))
  )
    return null;
  return (
    <SocketContextProvider>
      <AppInternetReconnectingBox />
      <HomeLayoutWrap>
        <SocketSessionInfoModel />
        <HomeLayoutWrapLeft>
          <LeftMenu />
        </HomeLayoutWrapLeft>
        <HomeLayoutWrapRight>
          <TopMenu />
          {userConfig?.payload?.subscription_active ||
          location?.pathname?.includes("subscription-plans/plans") ||
          location?.pathname?.includes("subscription/success") ? (
            <ContentWrap id="main-section">
              <NotificationBar />
              <Suspense fallback={<LinearLoader />}>
                <Outlet />
              </Suspense>
            </ContentWrap>
          ) : (
            <ExpireSubscription />
          )}
        </HomeLayoutWrapRight>
      </HomeLayoutWrap>
    </SocketContextProvider>
  );
};

export default ProtectedLayout;
